"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableBody_1 = require("./TableBody");
exports.default = TableBody_1.default;
//# sourceMappingURL=index.js.map